import { RouteObject } from 'react-router-dom';
import PATH from './path';
import ProtectedPrivateRoute from '../components/template/ProtectedPrivateRoute';
import DashBoardPage from '@/src/pages/DashBoard';
import NoticeCreatePage from '@/src/pages/notice/Create';
import NoticeDetailPage from '@/src/pages/notice/Detail';
import NoticeListPage from '@/src/pages/notice';
import FaqCreatePage from '../pages/faq/Create';
import AdministratorListPage from '@/src/pages/Administrator';
import AdministratorCreatePage from '@/src/pages/Administrator/Create';
import AdministratorDetailPage from '@/src/pages/Administrator/Detail';
import FaqListPage from '@/src/pages/faq';
import FaqDetailPage from '@/src/pages/faq/Detail';
import FaqEditPage from '@/src/pages/faq/Edit';
import AdministratorEditPage from '@/src/pages/Administrator/Edit';
import NoticeEditPage from '@/src/pages/notice/Edit';
import InquiryListPage from '../pages/inquiry';
import InquiryDetailPage from '../pages/inquiry/Detail';
import NormalCustomerPage from 'src/pages/Customer/NormalCustomer';
import NormalCustomerDetailPage from '@/src/pages/Customer/NormalCustomer/Detail';
import MainBannerCreatePage from '../pages/mainBanner/Create';
import MainBannerListPage from '../pages/mainBanner';
import MainBannerDetailPage from '../pages/mainBanner/Detail';
import MainBannerEditPage from '../pages/mainBanner/Edit';
import SubBannerCreatePage from '../pages/subBanner/Create';
import SubBannerListPage from '../pages/subBanner';
import SubBannerDetailPage from '../pages/subBanner/Detail';
import SubBannerEditPage from '../pages/subBanner/Edit';
import PartnershipCompaniesListPage from '../pages/PartnershipCompanies';
import PartnershipLinksListPage from '../pages/PartnershipLinks';
import PartnershipLinkDetailPage from '../pages/PartnershipLinks/Detail';
import PartnershipLinkEditPage from '../pages/PartnershipLinks/Edit';
import PartnershipLinkCreatePage from '../pages/PartnershipLinks/Create';
import BusinessCustomerPage from '@/src/pages/Customer/BusinessCustomer';
import BusinessCustomerDetailPage from '@/src/pages/Customer/BusinessCustomer/Detail';
import RecyclingProductsListPage from '@/src/pages/RecyclingProducts';
import CreditListPage from '@/src/pages/Credit';
import MagazineListPage from '@/src/pages/Magazine';
import MagazineCreatePage from '@/src/pages/Magazine/Create';
import MagazineDetailPage from '@/src/pages/Magazine/Detail';
import MagazineEditPage from '@/src/pages/Magazine/Edit';
import RecyclingCouponListPage from '@/src/pages/RecyclingCoupon';
import RecyclingProductCreatePage from '@/src/pages/RecyclingProducts/Create';
import RecyclingProductDetailPage from '@/src/pages/RecyclingProducts/Detail';
import RecyclingProductEditPage from '@/src/pages/RecyclingProducts/Edit';
import RecyclingRequestsListPage from '@/src/pages/RecyclingRequests';
import RecyclingRequestsDetailPage from '@/src/pages/RecyclingRequests/Detail';
import RecyclingPackageProduct from '../pages/RecyclingPackageProduct';
import ComunityListPage from '@/src/pages/Community';
import ComunityReportListPage from '@/src/pages/CommunityReport';
import PushAlarmListPage from '@/src/pages/pushAlarm';
import EntryListPage from '@/src/pages/Entry';
import EntryCreatePage from '@/src/pages/Entry/Create';
import EntryDetailPage from '@/src/pages/Entry/Detail';
import EntryEditPage from '@/src/pages/Entry/Edit';
import DonationListPage from '@/src/pages/Donation';
import DonationCreatePage from '@/src/pages/Donation/Create';
import DonationDetailPage from '@/src/pages/Donation/Detail';
import DonationEditPage from '@/src/pages/Donation/Edit';
import PushAlarmCreatePage from '@/src/pages/pushAlarm/Create';
import PushAlarmDetailPage from '@/src/pages/pushAlarm/Detail';
import PushAlarmEditPage from '@/src/pages/pushAlarm/Edit';
import ChallengeListPage from '@/src/pages/Challenge';
import ChallengeCreatePage from '@/src/pages/Challenge/Create';
import ChallengeDetailPage from '@/src/pages/Challenge/Detail';
import ChallengeEditPage from '@/src/pages/Challenge/Edit';
import CommunityReportDetailPage from '@/src/pages/CommunityReport/Detail';
import CommunityDetailPage from '@/src/pages/Community/Detail';
import AppHomeContentPage from '@/src/pages/AppHomeContent';
import AppHomeContentCreatePage from '@/src/pages/AppHomeContent/Create';
import AppHomeContentDetailPage from '@/src/pages/AppHomeContent/Detail';
import AppHomeContentEditPage from '@/src/pages/AppHomeContent/Edit';

const privateRoute: RouteObject[] = [
  {
    element: <ProtectedPrivateRoute />,
    children: [
      {
        path: PATH.ROOT,
        element: <DashBoardPage />,
      },
      {
        path: PATH.ADMINISTRATOR_LIST,
        element: <AdministratorListPage />,
      },
      {
        path: PATH.ADMINISTRATOR_CREATE,
        element: <AdministratorCreatePage />,
      },
      {
        path: PATH.ADMINISTRATOR_DETAIL,
        element: <AdministratorDetailPage />,
      },
      {
        path: PATH.NOTICE_CREATE,
        element: <NoticeCreatePage />,
      },
      {
        path: PATH.NOTICE_DETAIL,
        element: <NoticeDetailPage />,
      },
      {
        path: PATH.NOTICE_LIST,
        element: <NoticeListPage />,
      },
      {
        path: PATH.NOTICE_EDIT,
        element: <NoticeEditPage />,
      },
      {
        path: PATH.ADMINISTRATOR_EDIT,
        element: <AdministratorEditPage />,
      },
      {
        path: PATH.FAQ_CREAET,
        element: <FaqCreatePage />,
      },
      {
        path: PATH.FAQ_LIST,
        element: <FaqListPage />,
      },
      {
        path: PATH.FAQ_DETAIL,
        element: <FaqDetailPage />,
      },
      {
        path: PATH.FAQ_EDIT,
        element: <FaqEditPage />,
      },
      {
        path: PATH.INQUIRY_LIST,
        element: <InquiryListPage />,
      },
      {
        path: PATH.INQUIRY_DETAIL,
        element: <InquiryDetailPage />,
      },
      {
        path: PATH.NORMAL_CUSTOMER_LIST,
        element: <NormalCustomerPage />,
      },
      {
        path: PATH.NORMAL_CUSTOMER_DETAIL,
        element: <NormalCustomerDetailPage />,
      },
      {
        path: PATH.BUSINESS_CUSTOMER_LIST,
        element: <BusinessCustomerPage />,
      },
      {
        path: PATH.BUSINESS_CUSTOMER_DETAIL,
        element: <BusinessCustomerDetailPage />,
      },
      {
        path: PATH.MAIN_BANNER_CREATE,
        element: <MainBannerCreatePage />,
      },
      {
        path: PATH.MAIN_BANNER_LIST,
        element: <MainBannerListPage />,
      },
      {
        path: PATH.MAIN_BANNER_DETAIL,
        element: <MainBannerDetailPage />,
      },
      {
        path: PATH.MAIN_BANNER_EDIT,
        element: <MainBannerEditPage />,
      },
      {
        path: PATH.SUB_BANNER_CREATE,
        element: <SubBannerCreatePage />,
      },
      {
        path: PATH.SUB_BANNER_LIST,
        element: <SubBannerListPage />,
      },
      {
        path: PATH.SUB_BANNER_DETAIL,
        element: <SubBannerDetailPage />,
      },
      {
        path: PATH.SUB_BANNER_EDIT,
        element: <SubBannerEditPage />,
      },
      {
        path: PATH.PARTNERSHIP_COMPANIES_LIST,
        element: <PartnershipCompaniesListPage />,
      },
      {
        path: PATH.PARTNERSHIP_LINKS_LIST,
        element: <PartnershipLinksListPage />,
      },
      {
        path: PATH.PARTNERSHIP_LINKS_DETAIL,
        element: <PartnershipLinkDetailPage />,
      },
      {
        path: PATH.PARTNERSHIP_LINKS_EDIT,
        element: <PartnershipLinkEditPage />,
      },
      {
        path: PATH.PARTNERSHIP_LINKS_CREATE,
        element: <PartnershipLinkCreatePage />,
      },
      {
        path: PATH.RECYCLING_PRODUCT_LIST,
        element: <RecyclingProductsListPage />,
      },
      {
        path: PATH.RECYCLING_PRODUCT_CREATE,
        element: <RecyclingProductCreatePage />,
      },
      {
        path: PATH.RECYCLING_PRODUCT_DETAIL,
        element: <RecyclingProductDetailPage />,
      },
      {
        path: PATH.RECYCLING_PRODUCT_EDIT,
        element: <RecyclingProductEditPage />,
      },
      {
        path: PATH.RECYCLING_REQUESTS_LIST,
        element: <RecyclingRequestsListPage />,
      },
      {
        path: PATH.RECYCLING_REQUESTS_DETAIL,
        element: <RecyclingRequestsDetailPage />,
      },
      {
        path: PATH.RECYCLING_PACKAGE_PRODUCTS,
        element: <RecyclingPackageProduct />,
      },
      {
        path: PATH.CREDIT_LIST,
        element: <CreditListPage />,
      },
      {
        path: PATH.RECYCLING_COUPON_LIST,
        element: <RecyclingCouponListPage />,
      },
      {
        path: PATH.MAGAZINE_LIST,
        element: <MagazineListPage />,
      },
      {
        path: PATH.MAGAZINE_CREATE,
        element: <MagazineCreatePage />,
      },
      {
        path: PATH.MAGAZINE_DETAIL,
        element: <MagazineDetailPage />,
      },
      {
        path: PATH.MAGAZINE_EDIT,
        element: <MagazineEditPage />,
      },
      {
        path: PATH.COMMUNITY_LIST,
        element: <ComunityListPage />,
      },
      {
        path: PATH.COMMUNITY_POSTING_DETAIL,
        element: <CommunityDetailPage />,
      },
      {
        path: PATH.COMMUNITY_COMMENT_DETAIL,
        element: <CommunityDetailPage />,
      },
      {
        path: PATH.COMMUNITY_REPORT_LIST,
        element: <ComunityReportListPage />,
      },
      {
        path: PATH.COMMUNITY_REPORT_DETAIL,
        element: <CommunityReportDetailPage />,
      },
      {
        path: PATH.PUSH_ALARM_LIST,
        element: <PushAlarmListPage />,
      },
      {
        path: PATH.PUSH_ALARM_CREATE,
        element: <PushAlarmCreatePage />,
      },
      {
        path: PATH.PUSH_ALARM_DETAIL,
        element: <PushAlarmDetailPage />,
      },
      {
        path: PATH.PUSH_ALARM_EDIT,
        element: <PushAlarmEditPage />,
      },
      {
        path: PATH.ENTRY_LIST,
        element: <EntryListPage />,
      },
      {
        path: PATH.ENTRY_CREATE,
        element: <EntryCreatePage />,
      },
      {
        path: PATH.ENTRY_DETAIL,
        element: <EntryDetailPage />,
      },
      {
        path: PATH.ENTRY_EDIT,
        element: <EntryEditPage />,
      },
      {
        path: PATH.DONATION_LIST,
        element: <DonationListPage />,
      },
      {
        path: PATH.DONATION_CREATE,
        element: <DonationCreatePage />,
      },
      {
        path: PATH.DONATION_DETAIL,
        element: <DonationDetailPage />,
      },
      {
        path: PATH.DONATION_EDIT,
        element: <DonationEditPage />,
      },
      {
        path: PATH.CHALLENGE_LIST,
        element: <ChallengeListPage />,
      },
      {
        path: PATH.CHALLENGE_CREATE,
        element: <ChallengeCreatePage />,
      },
      {
        path: PATH.CHALLENGE_DETAIL,
        element: <ChallengeDetailPage />,
      },
      {
        path: PATH.CHALLENGE_EDIT,
        element: <ChallengeEditPage />,
      },
      {
        path: PATH.APP_HOME_CONTENT_LIST,
        element: <AppHomeContentPage />,
      },
      {
        path: PATH.APP_HOME_CONTENT_CREATE,
        element: <AppHomeContentCreatePage />,
      },
      {
        path: PATH.APP_HOME_CONTENT_DETAIL,
        element: <AppHomeContentDetailPage />,
      },
      {
        path: PATH.APP_HOME_CONTENT_EDIT,
        element: <AppHomeContentEditPage />,
      },
    ],
  },
];
export default privateRoute;
